
import { Component, Prop, Vue } from "vue-property-decorator";
import User from "./models/User";
import Axios from "axios";
import { Getter } from "vuex-class";
import GlobalConfig from "./GlobalConfig";
import Footer from "@/components/Footer.vue";
import Header from "./components/Header.vue";
import SideBarC from "./components/SideBarC.vue";
import NewHeader from "./components/NewHeader.vue";

@Component({ components: { SideBarC, NewHeader,Header,Footer } })
export default class App extends Vue {
  @Getter("isLoggedIn") isLoggedIn: boolean;
  @Getter("user") user: User;
  public loadingPage:boolean = true;

  public created() {
    this.currentRouteName();
    this.registerHttpInterceptor();
    //
    //Register application insight user
    if (this.user.cedula) {
      this.$appInsight.setUserContext({
        authenticatedUserId: this.user.cedula,
        storeInCookie: true,
      });
    }
  }
  public mounted(){
    this.loadingPage=false; 
  }
  public registerHttpInterceptor(): void {
    var self = this;

    Axios.interceptors.request.use(
      async (request: any) => {
        var user = self.user;
        if (user && user.token) {
          var token = user.token;
          request.headers.common["Authorization"] = `Basic ${token}`;
        }
        return request;
      },
      async (error: any) => {
        return Promise.reject(error);
      }
    );
  }

  public currentRouteName():void {
        // console.log(this.$route);
    }

  
  get showNewHeader(){
    if(  this.$route.name == 'Dash-Board'|| this.$route.name =='Tour-Virtual'||this.$route.name =='home'||this.$route.path =='/')
      return true
  }
  get showOldHeader(){
    if(this.$route.name != 'login')
      return true
  }
}
